import { render, staticRenderFns } from "./OnlineStoresTab.vue?vue&type=template&id=4b6bbd36"
import script from "./OnlineStoresTab.vue?vue&type=script&lang=js"
export * from "./OnlineStoresTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports